// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Fs-z","giftOrPromoSelector":"Gs-z","disabled":"Hs-z","subTitle":"Is-z","selectShipAddressMessage":"Js-z","changePayment":"Ks-z"};